import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as OwnOperationIcon } from 'assets/icons/factory.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';

import { IS_VC_UNIT_CARD_DETAILS_VISIBLE } from '../../../../../../constants/general';
import { formatRevenueAndPercentage } from '../../../../../../utils/helpers';
import CustomNodeItem from '../../BusinessStructure/components/CustomNodeItem';

import type { IOwnOperationNode } from '../interfaces/IOwnOperationNode';

import styles from '../sass/CustomUnitNode.module.scss';

function OwnOperationNode({
  name,
  profitCenterIds,
  naceSection,
  addressCountry,
  assetCategory,
  netBookValue,
  isCollapsed,
  isDraft,
  showDraftDeleteButton = true,
  cardsInsideCount,
  onDraftDelete,
}: IOwnOperationNode) {
  const { t } = useTranslation();

  const customNodeItems = [
    {
      title: t('valueChainMap.profitCenterId'),
      value: profitCenterIds?.join(', ') || '-',
    },
    {
      title: t('valueChainMap.naceSection'),
      value: naceSection || '-',
      isCapitalize: true,
    },
    {
      title: t('valueChainMap.country'),
      value: addressCountry || '-',
      isCapitalize: true,
    },
    {
      title: t('valueChainMap.bookValue'),
      value: formatRevenueAndPercentage({
        actual: netBookValue?.amount,
        currency: netBookValue?.currency,
      }),
    },
    {
      title: t('valueChainMap.assetCategory'),
      value: assetCategory?.join(', ') || '-',
      isCapitalize: true,
    },
  ];

  return (
    <>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <OwnOperationIcon />
          <p className={styles.title}>{name}</p>
        </div>
        <div className={styles.headerRight}>
          {isCollapsed && cardsInsideCount && cardsInsideCount > 0 ? (
            <span className={styles.cardsCount}>{cardsInsideCount}</span>
          ) : null}
          {isDraft && showDraftDeleteButton ? (
            <button
              type="button"
              className={styles.draftDeleteButton}
              aria-label={t('common.delete')}
              onClick={(event) => {
                event.stopPropagation();
                onDraftDelete?.();
              }}
            >
              <TrashIcon className={styles.draftDeleteIcon} />
            </button>
          ) : null}
        </div>
      </div>
      {IS_VC_UNIT_CARD_DETAILS_VISIBLE && !isCollapsed ? (
        <div className={styles.content}>
          {customNodeItems.map(({ title, value, isCapitalize }) => (
            <CustomNodeItem
              key={`customNodeItems_${title}`}
              title={title}
              value={value}
              isCapitalize={isCapitalize}
            />
          ))}
        </div>
      ) : null}
    </>
  );
}

export default OwnOperationNode;
